import { s } from "../../typography.module-Clhw1hCq.js";
const typoMapping = {
  "work-sans/heading-40": s["work-sans-heading-40"],
  "work-sans/heading-32": s["work-sans-heading-32"],
  "work-sans/heading-28": s["work-sans-heading-28"],
  "work-sans/heading-24": s["work-sans-heading-24"],
  "work-sans/heading-20": s["work-sans-heading-20"],
  "work-sans/heading-16": s["work-sans-heading-16"],
  "work-sans/text-xl--regular": s["work-sans-20-regular"],
  "work-sans/text-xl--medium": s["work-sans-20-medium"],
  "work-sans/text-lg--regular": s["work-sans-16-regular"],
  "work-sans/text-lg--medium": s["work-sans-16-medium"],
  "work-sans/text-lg--semi-bold": s["work-sans-16-semi-bold"],
  "work-sans/text-md--regular": s["work-sans-14-regular"],
  "work-sans/text-md--medium": s["work-sans-14-medium"],
  "work-sans/text-md--semi-bold": s["work-sans-14-semi-bold"],
  "work-sans/text-sm--medium": s["work-sans-13-medium"],
  "work-sans/text-sm--semi-bold": s["work-sans-13-semi-bold"],
  "work-sans/text-xs--regular": s["work-sans-12-regular"],
  "work-sans/text-xs--regular-trimmed": s["work-sans-text-xs--regular-trimmed"],
  "work-sans/text-xs--medium": s["work-sans-12-medium"],
  "work-sans/text-xs--semi-bold": s["work-sans-12-semi-bold"],
  "work-sans/uppercase-md--regular": s["work-sans-uppercase-14-regular"],
  "work-sans/uppercase-md--medium": s["work-sans-uppercase-14-medium"],
  "work-sans/uppercase-xs--medium": s["work-sans-uppercase-12-medium"],
  "work-sans/uppercase-xs--semi-bold": s["work-sans-uppercase-12-semi-bold"],
  "work-sans/uppercase-9--semi-bold": s["work-sans-uppercase-9-semi-bold"],
  "nkduy-mono/numerical-32--medium": s["nkduy-mono-numerical-32-medium"],
  "nkduy-mono/numerical-24--regular": s["nkduy-mono-numerical-24-regular"],
  "nkduy-mono/numerical-xl--regular": s["nkduy-mono-numerical-20-regular"],
  "nkduy-mono/numerical-lg--regular": s["nkduy-mono-numerical-16-regular"],
  "nkduy-mono/numerical-lg--medium": s["nkduy-mono-numerical-16-medium"],
  "nkduy-mono/numerical-lg--bold": s["nkduy-mono-numerical-16-bold"],
  "nkduy-mono/numerical-md--medium": s["nkduy-mono-numerical-14-medium"],
  "nkduy-mono/numerical-md--semi-bold": s["nkduy-mono-numerical-14-semi-bold"],
  "nkduy-mono/numerical-md--bold": s["nkduy-mono-numerical-14-bold"],
  "nkduy-mono/numerical-sm--medium": s["nkduy-mono-numerical-13-medium"],
  "nkduy-mono/numerical-sm--semi-bold": s["nkduy-mono-numerical-13-semi-bold"],
  "nkduy-mono/numerical-sm--semi-bold-trimmed": s["nkduy-mono-numerical-sm--semi-bold-trimmed"],
  "nkduy-mono/numerical-sm--bold": s["nkduy-mono-numerical-13-bold"],
  "nkduy-mono/numerical-xs--semi-bold": s["nkduy-mono-numerical-12-semi-bold"],
  "nkduy-mono/numerical-xs--bold": s["nkduy-mono-numerical-12-bold"]
};
export {
  typoMapping
};
